import React from "react"
import _map from "lodash/map"

import Typograph from "components/Typograph"

import styles from "./styles.css"

import MoneyIcon from "assets/svg/money-icon.svg"
import PartnershipIcon from "assets/svg/partnership-icon.svg"
import SustainableIcon from "assets/svg/sustainable-icon.svg"

const benefits = [
  {
    icon: MoneyIcon,
    alt: "Adesão gratuita",
    title: "Adesão gratuita",
    description: "Sem custos com equipamentos, mão de obra ou financiamento."
  },
  {
    icon: PartnershipIcon,
    alt: "Adesão digital",
    title: "Adesão 100% digital",
    description:
      "Assine de forma rápida e segura, direto com nosso especialista em energia."
  },
  {
    icon: SustainableIcon,
    alt: "Sustentabilidade",
    title: "Sustentável e econômica",
    description: "Energia limpa, renovável e barata. Gere valor para sua marca!"
  }
]

function BenefitCard() {
  return (
    <div className={styles.benefitCardContainer}>
      {_map(benefits, ({ title, description, icon, alt }) => (
        <div key={title}>
          <img src={icon} alt={alt} />
          <Typograph
            htmlTag="h3"
            size="extra_small"
            weight="bold"
            color="outer_space"
            classNames={styles.title}
          >
            {title}
          </Typograph>
          <Typograph
            htmlTag="p"
            size="extra_small"
            weight="medium"
            color="outer_space"
          >
            {description}
          </Typograph>
        </div>
      ))}
    </div>
  )
}
export default BenefitCard



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/BenefitCard/index.js